export default __webpack_public_path__ + "static/media/no_auth@2x.1307221c.png";